import { LinearProgress } from "@mui/material";
import React, { memo } from "react";

const Fallback = ({ bottom, top = 0, mb = 0, isLoading = true }) => {
  return (
    <LinearProgress
      sx={{
        width: "100%",
        height: isLoading ? 3 : 0,
        position: "absolute",
        top: bottom ? undefined : top,
        bottom: bottom ? mb : undefined,
        left: 0,
        zIndex: (t) => t.zIndex.appBar + 100,
        transition: ".2s ease",
      }}
    />
  );
};

export default memo(Fallback);
